import { Action } from "@ngrx/store";
import {
  InferredData,
  AccountingBasisPrefs,
  ActiveMexCut,
  AnalyticsData,
  HistoricalEstimates,
  Periods,
  GetSourceMetaParams,
  Visualizations,
} from "../models/right-panel-models";

export const SET_DISPLAY = "SHOW_HIDE_RIGHT_PANEL";
export const SET_RIGHT_PANEL_COLLAPSED = "SET_RIGHT_PANEL_COLLAPSED";
export const GET_ACCOUNTING_BASIS_PREFS = "GET_ACCOUNTING_BASIS_PREFS";
export const SET_ACCOUNTING_BASIS_PREFS = "SET_ACCOUNTING_BASIS_PREFS";

export const GET_ACTIVE_CUT = "GET_ACTIVE_CUT";
export const SET_ACTIVE_CUT = "SET_ACTIVE_CUT";

export const SET_INFERRED_SELECTED = "SET_INFERRED_SELECTED";
export const RESET_INFERRED_SELECTED = "RESET_INFERRED_SELECTED";

export const SET_ANALYTICS_DATA = "SET_ANALYTICS_DATA";
export const GET_ANALYTICS_DATA = "GET_ANALYTICS_DATA";

export const SET_HISTORICAL_ESTIMATES = "SET_HISTORICAL_ESTIMATES";
export const GET_HISTORICAL_ESTIMATES = "GET_HISTORICAL_ESTIMATES";
export const RESET_HISTORICAL_ESTIMATES = "RESET_HISTORICAL_ESTIMATES";

export const SET_PERIODS = "SET_PERIODS";
export const GET_PERIODS = "GET_PERIODS";
export const RESET_PERIODS = "RESET_PERIODS";

export const GET_SOURCE_META = "GET_SOURCE_META";

export const SET_VISUALIZATIONS = "SET_VISUALIZATIONS";
export const GET_VISUALIZATIONS = "GET_VISUALIZATIONS";
export const RESET_VISUALIZATIONS = "RESET_VISUALIZATIONS";
export const RESET_RIGHTPANEL_SETTIINGS = "RESET_RIGHTPANEL_SETTIINGS";
export const SET_SOURCE_META_LOADING = "SET_SOURCE_META_LOADING";
export const SET_SOURCE_META_GRID_FILTERS = "SET_SOURCE_META_GRID_FILTERS";

export class SetSourceMetaLoading implements Action {
  readonly type = SET_SOURCE_META_LOADING;
}

export class SetSourceMetaGridFilters implements Action {
  readonly type = SET_SOURCE_META_GRID_FILTERS;
  constructor(public payload: boolean) {}
}

export class SetDisplay implements Action {
  readonly type = SET_DISPLAY;
  constructor(public payload: boolean) {}
}

export class GetAccountingBasisPref implements Action {
  readonly type = GET_ACCOUNTING_BASIS_PREFS;
  constructor(public payload: AccountingBasisPrefs) {}
}

export class SetAccountingBasisPref implements Action {
  readonly type = SET_ACCOUNTING_BASIS_PREFS;
  constructor(public payload: AccountingBasisPrefs) {}
}

// just to check, later move to separate mex -> ticker specific store
export class GetActiveCut implements Action {
  readonly type = GET_ACTIVE_CUT;
  constructor(public payload: ActiveMexCut) {}
}

export class SetActiveCut implements Action {
  readonly type = SET_ACTIVE_CUT;
  constructor(public payload: ActiveMexCut) {}
}

export class SetInferred implements Action {
  readonly type = SET_INFERRED_SELECTED;
  constructor(public payload: InferredData) {}
}

export class ResetInferred implements Action {
  readonly type = RESET_INFERRED_SELECTED;
}

export class SetAnalyticsData implements Action {
  readonly type = SET_ANALYTICS_DATA;
  constructor(public payload: AnalyticsData) {}
}

export class GetAnalyticsData implements Action {
  readonly type = GET_ANALYTICS_DATA;
}

export class SetHistoricalEstimates implements Action {
  readonly type = SET_HISTORICAL_ESTIMATES;
  constructor(public payload: HistoricalEstimates) {}
}

export class GetHistoricalEstimates implements Action {
  readonly type = GET_HISTORICAL_ESTIMATES;
}

export class ResetHistoricalEstimates implements Action {
  readonly type = RESET_HISTORICAL_ESTIMATES;
}

export class SetPeriods implements Action {
  readonly type = SET_PERIODS;
  constructor(public payload: Periods) {}
}

export class GetPeriods implements Action {
  readonly type = GET_PERIODS;
}

export class ResetPeriods implements Action {
  readonly type = RESET_PERIODS;
}

export class GetSourceMeta implements Action {
  readonly type = GET_SOURCE_META;
  constructor(public payload: GetSourceMetaParams) {}
}

export class SetVisualizations implements Action {
  readonly type = SET_VISUALIZATIONS;
  constructor(public payload: Visualizations) {}
}

export class GetVisualizations implements Action {
  readonly type = GET_VISUALIZATIONS;
}

export class SetRightPanelCollapsed implements Action {
  readonly type = SET_RIGHT_PANEL_COLLAPSED;
  constructor(public payload: boolean) {}
}

export class ResetVisualizations implements Action {
  readonly type = RESET_VISUALIZATIONS;
}

export class ResetRightPanelSettings implements Action {
  readonly type = RESET_RIGHTPANEL_SETTIINGS;
}

export type Actions =
  | SetSourceMetaLoading
  | SetDisplay
  | SetInferred
  | ResetInferred
  | GetAccountingBasisPref
  | SetAccountingBasisPref
  | GetActiveCut
  | SetActiveCut
  | SetAnalyticsData
  | GetAnalyticsData
  | GetHistoricalEstimates
  | SetHistoricalEstimates
  | ResetHistoricalEstimates
  | SetPeriods
  | GetPeriods
  | ResetPeriods
  | GetSourceMeta
  | SetVisualizations
  | GetVisualizations
  | ResetVisualizations
  | ResetRightPanelSettings
  | SetSourceMetaGridFilters
  | SetRightPanelCollapsed;
